import { ModelContainer, GlobalErrorMessage, connected } from 'shared'
import { Model, UserRequestApi } from 'api'
import { PolymorphicModal } from '.'
import { debounce } from 'lodash'

export default class TopLevelPage extends Component {
  componentDidMount() {
    App.state.setObject({ base: this.props.base })
    // this.redirectToChatDebounced = debounce(this.redirectToChat, 500)
    // this.redirectToChatDebounced()
  }

  componentDidUpdate() {
    // this.redirectToChatDebounced()
  }

  componentWillUnmount() {
    // this.redirectToChatDebounced?.cancel()
  }

  async redirectToChat() {
    if (!User.current?.id) return
    if (window.location.href.includes("settings")) return
    await User.refresh()
    let { modelId } = this.props
    if(modelId != 'chat' && User.current.manualWorkflowId != 'null') {
      console.log('redirectToChat', modelId, User.current)
      if(User.current.pendingUserRequestId != 'null') {
        App.state.setObject({
          'chat:selectedUserRequestId': `user-request:${User.current.pendingUserRequestId}`,
          'chat:smartButton': undefined
        })
        App.openChat()
      } else {
        let newRequest = await UserRequestApi.create({ id: User.current.manualWorkflowId })
        if (newRequest) {
          UserRequestApi.addToCollection('index', newRequest)
          App.state.setObject({
            'chat:selectedUserRequestId': newRequest.uid,
            'chat:smartButton': undefined
          })
          App.openChat()
        } else {
          console.warn("Failed to create new user request for manual workflow ID: ", User.current.manualWorkflowId)
        }
      }
    }
  }

  render() {
    let { className, modelId, children, fullWidth } = this.props
    if (User.current && User.current.mustChangePassword)
      App.go('change-password')

    return (
      <div className={classNames(className, { container: !fullWidth })}>
        {children}
        {this.renderModal()}
        {App.state.error && <GlobalErrorMessage />}
      </div>
    )
  }

  renderModal() {
    let { modelId, base, ModalClass = PolymorphicModal } = this.props

    let activeModalType = application.state.getObject('activeModalType')
    if (activeModalType) return <ModalClass model={activeModalType} returnUrl={base} />

    if (modelId == null) return null
    if (modelId == 'chat') return <ModalClass model='chat' returnUrl={base} />
    if (modelId == 'guest-signup') return <ModalClass model='guest-signup' returnUrl={base} />

    let pureModelId = Model.extractPureModelId(modelId)
    let subroute = Model.extractSubroute(modelId)

    return <ModelContainer modelId={pureModelId}>
      { model => <ModalClass model={model} returnUrl={base} subroute={subroute} /> }
    </ModelContainer>
  }
}
